export default function (store) {
    const { taskShape } = store.getState();
    taskShape.completed.taskHide = true;
    store.setState({ taskShape });
}
//# sourceMappingURL=hideCompleted.js.map